// src/hooks/useChallengeData.js
import { useState, useEffect } from "react";
import {
  doc,
  getDoc,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import { db } from "../firebase"; // Ensure this path is correct based on your project structure

const useChallengeData = (challengeId, currentUserId) => {
  const [challenge, setChallenge] = useState(null);
  const [creatorInfo, setCreatorInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isOwner, setIsOwner] = useState(false);
  const [hasSubmissions, setHasSubmissions] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchChallengeData = async () => {
      if (!challengeId) {
        setLoading(false); // No challengeId implies 'create' mode
        return;
      }

      if (!currentUserId) {
        setError("User not authenticated.");
        setLoading(false);
        return;
      }

      try {
        setLoading(true);

        // Fetch the challenge document
        const challengeDocRef = doc(db, "challenges", challengeId);
        const challengeDocSnap = await getDoc(challengeDocRef);

        if (challengeDocSnap.exists()) {
          const data = challengeDocSnap.data();
          setChallenge(data);
          setCreatorInfo(data.creatorInfo);

          // Determine if the current user is the owner
          setIsOwner(data.creatorInfo.creatorUid === currentUserId);

          // Check for published submissions
          const submissionsRef = collection(db, "submissions");
          const submissionsQuery = query(
            submissionsRef,
            where("challengeId", "==", challengeId),
            where("status", "==", "published")
          );
          const submissionsSnap = await getDocs(submissionsQuery);
          setHasSubmissions(!submissionsSnap.empty);
        } else {
          setError("Challenge not found.");
        }
      } catch (err) {
        console.error("Error fetching challenge data:", err);
        setError("Failed to fetch challenge data.");
      } finally {
        setLoading(false);
      }
    };

    fetchChallengeData();
  }, [challengeId, currentUserId]);

  return { creatorInfo, challenge, loading, isOwner, hasSubmissions, error };
};

export default useChallengeData;
